import React, { useState, useEffect } from "react";
import { Home } from "./Pages/Home";
import { LandingPage } from "./Components/LandingPage";
import { Routes, Route } from "react-router-dom";
import { About } from "./Pages/About/About";
import { Service } from "./Pages/Services/Service";
import { Faq } from "./Pages/Faq/Faq";
import { Contact } from "./Pages/Contact/Contact";
import { PopupModal } from "react-calendly";
import { Privacy } from "./Pages/privacy/Privacy";
import { Terms } from "./Pages/terms/Terms";
import { Booking } from "./Pages/Booking/Booking";
import { SoftwareDev } from "./Pages/Ads-Pages/Software-Dev/SoftwareDev";
const App = () => {
  const [selectedPage, setSelectedPage] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleScroll = () => {
    const scrollTop = window.scrollY || window.pageYOffSet;

    if (scrollTop > 500) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <LandingPage
              selectedPage={selectedPage}
              setSelectedPage={setSelectedPage}
              setIsOpen={setIsOpen}
            />
          }
        >
          <Route
            index
            element={
              <Home setSelectedPage={setSelectedPage} setIsOpen={setIsOpen} />
            }
          />
          <Route
            path="about-us"
            element={
              <About setSelectedPage={setSelectedPage} setIsOpen={setIsOpen} />
            }
          />
          <Route
            path="services/:id"
            element={
              <Service
                setSelectedPage={setSelectedPage}
                setIsOpen={setIsOpen}
              />
            }
          />
          <Route
            path="faq"
            element={<Faq setSelectedPage={setSelectedPage} />}
          />
          <Route
            path="contact-us"
            element={<Contact setSelectedPage={setSelectedPage} />}
          />

          <Route path="term-and-condition" element={<Terms />} />
          <Route path="privacy-policy" element={<Privacy />} />

          <Route path="book-now" element={<Booking />} />
        </Route>

        <Route path="software-development" element={<SoftwareDev />} />
      </Routes>

      <PopupModal
        url="https://calendly.com/datadept-ca/30min"
        /*
         * react-calendly uses React's Portal feature (https://reactjs.org/docs/portals.html) to render the popup modal. As a result, you'll need to
         * specify the rootElement property to ensure that the modal is inserted into the correct domNode.
         */
        open={isOpen}
        rootElement={document.getElementById("root")}
        onModalClose={() => setIsOpen(false)}
      />

      {isVisible && (
        <button className="back-to-top" onClick={scrollToTop}>
          <i className="bi bi-arrow-up"></i>
        </button>
      )}
    </>
  );
};

export default App;
